import type { InlineResponseChatBlock, SharedMessageItem } from "../../containers/chat/chat.shared.types";

type InlineResponseMetadata = {
  question?: string;
  choices?: string[];
  source?: string;
};

export function inlineResponseBlocksFromMetadata(
  metadata?: Record<string, unknown> | null,
  options?: { requireSource?: boolean }
): InlineResponseChatBlock[] {
  const inlineData = metadata?.inlineResponse as InlineResponseMetadata | undefined;
  if (options?.requireSource && !inlineData?.source) {
    return [];
  }
  if (
    !inlineData?.question ||
    !Array.isArray(inlineData.choices) ||
    inlineData.choices.length < 2 ||
    !inlineData.choices.every((choice) => typeof choice === "string")
  ) {
    return [];
  }

  return [
    {
      kind: "inline_response",
      question: inlineData.question,
      choices: inlineData.choices,
      selectedChoiceIndex: null,
      submitted: false,
    },
  ];
}

export function appendInlineResponseFromMetadata<T extends SharedMessageItem>(
  message: T,
  metadata?: Record<string, unknown>
): T {
  const inlineBlocks = inlineResponseBlocksFromMetadata(metadata, { requireSource: true });
  if (inlineBlocks.length === 0) {
    return message;
  }

  const inlineBlock = inlineBlocks[0];
  const blocks = message.blocks ?? [];
  const alreadyExists = blocks.some(
    (block) => block.kind === "inline_response" && block.question === inlineBlock.question
  );
  if (alreadyExists) {
    return message;
  }

  return { ...message, blocks: [...blocks, inlineBlock] };
}
